import { Constants } from '../common/Constants';
import { PUSH_SRC_TYPE } from '../common/Enumerations';
import { Logger } from '../common/Logger';
import { LoggerTexts } from '../common/LoggerTexts';
import { JSONValue } from '../common/Types';

export class PushContextData {
	private _type: PUSH_SRC_TYPE = PUSH_SRC_TYPE.unknown;
	private _areaId: string;
	private _triggerName: string;
	private _shortText?: string;
	private _payload?: JSONValue;
	private readonly _logger: Logger;

	constructor(areaId: string, triggerName: string, shortText?: string, payload?: JSONValue) {
		this._logger = new Logger(Constants.FILE_PUSH_CONTEXT_DATA);
		this._areaId = areaId;
		this._triggerName = triggerName;
		this._shortText = shortText?.trim();
		this._payload = this._verifyPayload(payload);
	}

	set type(value: PUSH_SRC_TYPE) {
		this._type = value;
	}

	get type(): PUSH_SRC_TYPE {
		return this._type;
	}

	get areaId(): string {
		return this._areaId;
	}

	get triggerName(): string {
		return this._triggerName;
	}

	get shortText(): string {
		return this._shortText || Constants.VALUE_NOT_AVAILABLE;
	}

	get payloadToString(): string | undefined {
		return this._payload ? JSON.stringify(this._payload) : undefined;
	}

	private _verifyPayload(payload: JSONValue | undefined) {
		if (payload) {
			try {
				const payloadString = JSON.stringify(payload);
				if (payloadString.length > Constants.LIMITS.MAX_APP_TRIGGERED_PUSH_PAYLOAD_SIZE_IN_CHARS) {
					this._logger.error(
						`'payload' size has exceeded its limit of ${Constants.LIMITS.MAX_APP_TRIGGERED_PUSH_PAYLOAD_SIZE_IN_CHARS} characters in PushFeedbackRequestData!. payload will be set to 'null'.`
					);
				} else {
					return JSON.parse(payloadString);
				}
			} catch (error) {
				throw Error(LoggerTexts.PUSH_CONTEXT_DATA.INVALID_PAYLOAD);
			}
		}
		return undefined;
	}
}
